import { configureStore } from "@reduxjs/toolkit";
import questionsReducer from "./faqSlice";
import categoriesReducer from "./categoriesSlice";
import authReducer from "./authSlice";
import createOrderReducer from "./createOrderSlice";
import countriesReducer from "./countriesSlice";
import orderwithidReducer from "./ShowOrderIdSlice";
import orderUpdateReducer from "./orderUpdateSlice";
import paymentTypeReducer from "./paymentTypeSlice";
import getUserReducer from "./getUserSlice";
import profileUpdateReducer from "./profileUpdateSlice";
import rateOrderReducer from "./rateOrderSlice";
import createChatAgentReducer from "./createChatAgentSlice";
import sendMSReducer from "./sendMSSlice";
import previewsConstructionReducer from "./previewsConstructionStatusSlice";
import previewsUpdateReducer from "./previewsUpdateSlice";
import showPreviewIdReducer from "./showPreviewIdSlice";
import createPreviewReducer from "./createPreviewSlice";
import getPropertyReducer from "./getPropertySlice";
import companyDataReducer from "./companyDataSlice";
import acceptOfferReducer from "./acceptOfferSlice";
import constructionServicesReducer from "./constructionServicesSlice";
import getAgentRateIdReducer from "./getAgentRateIdSlice";
import createChatAdminReducer from "./createChatAdminSlice";
import allNotificationReducer from "./allNotificationSlice";
import updateImageProfileReducer from "./updateImageProfileSlice";
import categoriesProductsReducer from "./ecommerce/categoriesProductsSlice";
import productsReducer from "./ecommerce/productsSlice";
import cartReducer from "./ecommerce/cartSlice";
import joinSamoolahReducer from "./ecommerce/joinSamoolahSlice";
import payNinetyPreviewReducer from "./payNinetyPreviewSlice";
import ratePreviewReducer from "./ratePreviewSlice";
import getTirmsReducer from "./getTirmsSlice";
import footerReducer from "./footerSlice";
import testimonialReducer from "./testimonialSlice";
import facilitesServicesReducer from "./facilitesServicesSlice";
import facilitescategoryReducer from "./facilitesCategoriesSlice";
import videoReducer from "./videoSlice";
import politesReducer from "./politeSlice";
import favoriteSlice from "./ecommerce/favoriteSlice";
import bestSellerProductsSlice from "./ecommerce/bestSellerProductsSlice";
import submitOrderReducer from "./ecommerce/submitOrderSlice";

export const store = configureStore({
  reducer: {
    questions: questionsReducer,
    categories: categoriesReducer,
    auth: authReducer,
    createOrder: createOrderReducer,
    countries: countriesReducer,
    order: orderwithidReducer,
    updateOrder: orderUpdateReducer,
    paymentType: paymentTypeReducer,
    getUser: getUserReducer,
    updateProfile: profileUpdateReducer,
    rateOrder: rateOrderReducer,
    createChatAgent: createChatAgentReducer,
    sendMS: sendMSReducer,
    perviews: previewsConstructionReducer,
    updatePreview: previewsUpdateReducer,
    showPreviewId: showPreviewIdReducer,
    createPreview: createPreviewReducer,
    properties: getPropertyReducer,
    companyData: companyDataReducer,
    acceptOffer: acceptOfferReducer,
    constructionServices: constructionServicesReducer,
    AgentRate: getAgentRateIdReducer,
    createChatAdmin: createChatAdminReducer,
    allNotification: allNotificationReducer,
    updateImageProfile: updateImageProfileReducer,
    categoriesProducts: categoriesProductsReducer,
    products: productsReducer,
    cart: cartReducer,
    joinSamoolah: joinSamoolahReducer,
    payNinetyPreview: payNinetyPreviewReducer,
    ratePreview: ratePreviewReducer,
    tirms: getTirmsReducer,
    footer: footerReducer,
    testimonials: testimonialReducer,
    facilitesServices: facilitesServicesReducer,
    facilitescategory: facilitescategoryReducer,
    video: videoReducer,
    polites: politesReducer,
    favourite:favoriteSlice,
    bestProducts:bestSellerProductsSlice,
    submitOrder: submitOrderReducer,
  },
});

export default store;
